import script from "./OnboardingGroupeItemDetailsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnboardingGroupeItemDetailsModal.vue?vue&type=script&setup=true&lang=ts"

import "./OnboardingGroupeItemDetailsModal.vue?vue&type=style&index=0&id=39b9cf9b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39b9cf9b"]])

export default __exports__